import { GroupCreator } from './GroupEditor/GroupCreator';
import 'twin.macro';
import { Eleve } from 'types/eleves';
import React from 'react';
import { EditingGroup } from './GroupEditor/types';
import usePopoverContext from 'components/Popover/usePopoverContext';

interface Props {
  onDeleteGroup: (id: string) => void;
  eleves: Eleve[];
  group: EditingGroup;
  onSubmit: (e: EditingGroup) => void;
}

export function GroupEditorPanel(props: Props) {
  const { onDeleteGroup, eleves } = props;
  const { close } = usePopoverContext();
  const [groupBeingEdited, setGroupBeingEdited] = React.useState<EditingGroup>(
    props.group,
  );
  return (
    <div tw="space-y-4 px-4 pt-4">
      <GroupCreator
        eleves={eleves}
        onDelete={() => {
          if (groupBeingEdited.id) {
            onDeleteGroup(groupBeingEdited.id);
          }
        }}
        onChange={g => setGroupBeingEdited(g)}
        onSubmit={() => {
          props.onSubmit(groupBeingEdited);
          close?.();
        }}
        onCancel={() => {
          setGroupBeingEdited(props.group);
          close?.();
        }}
        value={groupBeingEdited}
      />
    </div>
  );
}
